export const getCities = async (country: string, namePrefix?: string) => {
  try {
    let url = `https://wft-geo-db.p.rapidapi.com/v1/geo/cities?countryIds=${country}`;

    if (namePrefix && namePrefix.trim()) {
      url += `&namePrefix=${encodeURIComponent(namePrefix.trim())}`;
    }

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'x-rapidapi-key': 'aefb418cc8msh71e70972c5879b8p10809djsnbc62e27e1bac',
        'x-rapidapi-host': 'wft-geo-db.p.rapidapi.com'
      }
    });

    const data = await res.json();
    return data.data || [];
  } catch (error) {
    return [];
  }
};
